import fly, { genFormData } from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()

export const fetchNavlist = (depot_id: string) =>
  fly.get('/mall/common/navlist.json', { depot_id, auth }).then(res => res.data)

export const fetchGoods = (params: Object) =>
  fly.get('/mall/common/index.json', { ...params, auth }).then(res => res.data)

export const addGood = (params: any) =>
  fly.post('/mall/cs/shoppingbag/add.json', genFormData({ ...params, auth }))
export const delGood = (params: any) =>
  fly.post('/mall/cs/shoppingbag/reduce.json', genFormData({ ...params, auth }))
export const fetchGoodsCount = (depot_id: string) =>
  fly
    .get('/mall/cs/shoppingbag/totalNum.json', { depot_id, auth })
